import { BrandMark } from './icons';
import './site.css';

export default function Tapume() {
  return (
    <div className="cc cc-tapume">
      <div className="cc-hero-orb o1" />
      <div className="cc-hero-orb o2" />
      <div className="cc-tp">
        <div className="cc-tp-mark"><BrandMark size={34} /></div>
        <div className="cc-tp-tag">Cloud Café &amp; DevOps</div>
        <h1 className="cc-tp-title">Vem <span className="cc-serif">novidade</span> aí.</h1>
        <p className="cc-tp-sub">
          Estamos construindo uma nova forma de evoluir em tecnologia — do estágio ao sênior,
          com o Pensamento de Engenheiro no centro. Volta já já.
        </p>
        <div className="cc-tp-bar" />
        <div className="cc-tp-status">
          <span className="cc-c-prompt">$</span> deploy das novidades<span className="cc-tp-dots" /><span className="cc-cursor" />
        </div>
        <div className="cc-tp-foot">
          © {new Date().getFullYear()} Cloud Café &amp; DevOps · <a href="mailto:contato@cloudcafeedevops.io">contato@cloudcafeedevops.io</a>
        </div>
      </div>
    </div>
  );
}
